"use client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faComments,
  faUsers,
  faBalanceScale,
  faPuzzlePiece,
  faSyncAlt,
  faBrain,
  faPalette,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";

import { useTranslations } from "use-intl";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";

function getIcon(index: number): IconDefinition {
  switch (index) {
    case 1:
      return faComments;
    case 2:
      return faUsers;
    case 3:
      return faBalanceScale;
    case 4:
      return faPuzzlePiece;
    case 5:
      return faSyncAlt;
    case 6:
      return faBrain;
    case 7:
      return faPalette;
    case 8:
      return faMagnifyingGlass;
    default:
      return faBrain;
  }
}
export default function SoftSkillPanel() {
  const t = useTranslations("HomePage.resume");

  const entries = t.raw("softSkills.entries") as {
    minorSkillName: string;
    minorSkillState: string;
  }[];
  return (
    <div className="flex flex-row flex-wrap gap-3 ">
      {entries.map((entry, index) => (
        <div
          key={index}
          className="flex-1 sm:min-w-2xs flex flex-col flex-nowrap bg-secondary-grey p-10 rounded-md gap-3"
        >
          <FontAwesomeIcon className="text-3xl " icon={getIcon(index)} />
          <div>
            <p className="text-center">{entry.minorSkillName}</p>
            <p className="text-primary-yellow text-xs ">
              {entry.minorSkillState}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
